"use client";

import React from "react";
import { Card, Typography } from "@material-tailwind/react";
import CountUp from "react-countup";
import Image, { StaticImageData } from "next/image";

interface ManualCardProps {
  img: string;
  alt: string;
  count: string;
  title: string;
  client: string;
}

export default function ManualCard({ img, alt, count, title, client }: ManualCardProps) {
  const numeric = Number(count.replace(/,/g, ""));

  return (
    <Card {...({} as any)}  color="transparent" shadow={false} className="flex flex-col items-center text-center h-full">
      {/* Wrapper สำหรับ Next/Image */}
      <div className="relative w-40 h-40 flex justify-center items-center mb-6">
      <Image
        src={img}
        alt={alt}
        fill   
        // sizes="160px"
        className="object-contain"
        loading="lazy"
      />
      </div>

      <Typography  {...({} as any)}  as="p" variant="paragraph" color="blue-gray" className="font-semibold whitespace-pre-line tracking-wide">
        {title}
      </Typography>

      <Typography  {...({} as any)}  as="p" variant="paragraph" className="font-semibold tracking-wide text-[#2998E2]">
        {client}
      </Typography>
    </Card>
  );
}
